import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const CallsApi = {
  // Recovers a buffered call offer after a cold start (the app was fully
  // closed when the offer arrived, so it never reached a live WebSocket).
  getPendingCall: async () => {
    try {
      const response = await axiosInstance.get(Configs.getPendingCallEp);
      if (response.status === 200 && response.data.status === "success") {
        return response.data.data || null;
      }
      return null;
    } catch (error) {
      console.error("❌ Error fetching pending call:", error);
      return null;
    }
  },

  declineCall: async (callId) => {
    try {
      const response = await axiosInstance.post(Configs.declineCallEp, {
        call_id: callId,
      });
      return response.status === 200 && response.data.status === "success";
    } catch (error) {
      console.error("❌ Error declining call:", error);
      return false;
    }
  },
};

export default CallsApi;
